import React from 'react';
import Badge from '../components/Badge';
import betaIcon from '../icons/non-prefilled/16x16/beta.svg';

const BetaBadge = () => {
  return (
    <Badge color="red" icon={<Badge.Icon>{betaIcon}</Badge.Icon>}>
      Beta
    </Badge>
  );
};

export default BetaBadge;
